var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.waitingOnRender)?_c('div',{staticClass:"checkCellWrapper",style:(_vm.style)},[_c('a-checkbox',{attrs:{"checked":_vm.value,"aria-label":_vm.label,"disabled":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }